import { createFileRoute } from "@tanstack/react-router";
import SellMyCar from "@/pages/SellMyCar";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/vinde-masina/notify/")({
  head: () => routeHead("/vinde-masina/notify/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SellMyCar />
  );
}
